import React from "react";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import RichText from "@qlik/qlik/src/components/RichText";
import * as styles from "./styles.module.css";

const ContentWithListItem = ({ data }) => {
    const { additionalConfiguration, backgroundColor, cardItem, customId } = data || {};
    const { body } = cardItem || {};
    const spacingClassNames = getSpacingClassName(additionalConfiguration, "lg:py-30 py-5.5");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section className={`scroll-mt-35 ${spacingClassNames} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="container max-w-full">
                <div className="row">
                    <div className="col-12 ">
                        {body?.raw && (
                            <RichText
                                data={cardItem}
                                className={`${styles.listWrapper} ${sectionColorMapping.primaryTextColor}`}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContentWithListItem;
